import { Component } from '@theme/component';
import { ThemeEvents, VariantUpdateEvent, ZoomMediaSelectedEvent } from '@theme/events';

/**
 * A custom element that renders a media gallery.
 *
 * @typedef {object} Refs
 * @property {import('./zoom-dialog').ZoomDialog} [zoomDialogComponent] - The zoom dialog component.
 * @property {import('./slideshow').Slideshow} [slideshow] - The slideshow component.
 * @property {HTMLElement[]} [media] - The media elements.
 *
 * @extends Component<Refs>
 */
export class MediaGallery extends Component {
  
  /*connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#controller;
    const target = this.closest('.shopify-section, dialog');

    target?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate, { signal });
    this.refs.zoomDialogComponent?.addEventListener(ThemeEvents.zoomMediaSelected, this.#handleZoomMediaSelected, {
      signal,
    });
  }*/
 connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#controller;
    const target = this.closest('.shopify-section, dialog');

    target?.addEventListener(
        ThemeEvents.variantUpdate,
        this.#handleVariantUpdate,
        { signal }
    );

    this.refs.zoomDialogComponent?.addEventListener(
        ThemeEvents.zoomMediaSelected,
        this.#handleZoomMediaSelected,
        { signal }
    );



    // -----------------------------------------
    // Load gallery for initially selected variant
    // -----------------------------------------
    requestAnimationFrame(() => {

        const variantInput = document.querySelector(
            'input[name="id"]'
        );

        if (!variantInput) return;

        this.filterVariantImages({
            id: variantInput.value
        });
        this.setupHoverPause();
        this.startAutoplay();

    });


    
}

  #controller = new AbortController();
  #autoplayTimer = null;
  #currentSlide = 0;
  disconnectedCallback() {
    super.disconnectedCallback();

    this.#controller.abort();
  }


  /**
   * Handles a variant update event by replacing the current media gallery with a new one.
   *
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  #handleVariantUpdate = (event) => {
    const source = event.detail.data.html;

 // console.log('Variant Update Event:', event);

 // console.log(event.detail.data.html);
//  console.log(event.detail.data.html instanceof Document);
 // console.log(event.detail.data.html.querySelector?.('media-gallery'));

    if (!source) return;
    const newMediaGallery = source.querySelector('media-gallery');

    if (!newMediaGallery) return;

    this.replaceWith(newMediaGallery);

    requestAnimationFrame(() => {
        newMediaGallery.filterVariantImages(event.detail.resource);
    });

    // Reset quantity to 1
    const quantityInput = document.querySelector('quantity-input input[name="quantity"]')
        || document.querySelector('input[name="quantity"]');

    if (quantityInput) {
        quantityInput.value = 1;

        quantityInput.dispatchEvent(
            new Event('change', { bubbles: true })
        );

        quantityInput.dispatchEvent(
            new Event('input', { bubbles: true })
        );
    }
  };

  startAutoplay() {

    this.stopAutoplay();

    const slides = [...this.querySelectorAll('slideshow-slide')]
        .filter(slide => !slide.hidden);

    if (slides.length <= 1) return;

    this.#autoplayTimer = setInterval(() => {

        const visibleSlides = [...this.querySelectorAll('slideshow-slide')]
            .filter(slide => !slide.hidden);

        if (visibleSlides.length <= 1) return;

        this.#currentSlide++;

        if (this.#currentSlide >= visibleSlides.length) {
            this.#currentSlide = 0;
        }

        this.slideshow?.select(this.#currentSlide);

    }, 3000);
}

stopAutoplay() {

    if (this.#autoplayTimer) {
        clearInterval(this.#autoplayTimer);
        this.#autoplayTimer = null;
    }
}

setupHoverPause() {

    const gallery = this.querySelector('slideshow-component');

    if (!gallery) return;

    gallery.addEventListener('mouseenter', () => {
        this.stopAutoplay();
    });

    gallery.addEventListener('mouseleave', () => {
        this.startAutoplay();
    });

    const thumbs = this.querySelector('.slideshow-controls__thumbnails-container');

    if (thumbs) {

        thumbs.addEventListener('mouseenter', () => {
            this.stopAutoplay();
        });

        thumbs.addEventListener('mouseleave', () => {
            this.startAutoplay();
        });

    }
}

  filterVariantImages(variant) {

    /*const map = document.getElementById(
        `VariantGalleryMap-${variant.featured_image.product_id}`
    );

    if (!map) return;

    const gallery = JSON.parse(map.textContent);

    const images = gallery[String(variant.id)] || [];*/
    const map = document.getElementById(
      `VariantGalleryMap-${this.dataset.productId}`
  );

  if (!map) return;

  const gallery = JSON.parse(map.textContent);

  const images = gallery[String(variant.id)] || [];

  if (!images.length) return;

    if (!images.length) return;
    console.log(document.querySelector('media-gallery').innerHTML);
    // Main slideshow
    const slides = this.querySelectorAll('slideshow-slide');

    slides.forEach((slide, index) => {

        const img = slide.querySelector('img');

        if (!img) return;

        if (images[index]) {

            img.src = images[index];
            img.srcset = "";
            img.removeAttribute("sizes");
            slide.hidden = false;

        } else {

            slide.hidden = true;

        }

    });

    // Thumbnail grid
    const thumbs = this.querySelectorAll('.media-gallery__grid > li');

    thumbs.forEach((thumb, index) => {

        const img = thumb.querySelector('img');

        if (!img) return;

        if (images[index]) {

            img.src = images[index];
            img.srcset = "";
            img.removeAttribute("sizes");
            thumb.hidden = false;

        } else {

            thumb.hidden = true;

        }

    });

    // Zoom dialog
    this.media.forEach((item, index) => {

        const img = item.querySelector('img');

        if (!img) return;

        if (images[index]) {

            img.src = images[index];
            img.srcset = "";
            img.removeAttribute("sizes");
            item.hidden = false;

        } else {

            item.hidden = true;

        }

    });

    // -------------------------
// Thumbnails
// -------------------------
const thumbnails = this.querySelectorAll(
    '.slideshow-controls__thumbnail img'
);

thumbnails.forEach((img, index) => {

    const btn = img.closest('.slideshow-controls__thumbnail');

    if (images[index]) {

        // use a small thumbnail
        const thumb = images[index].replace(
            /width=\d+/,
            'width=144'
        );

        img.src = thumb;
        img.srcset = `${thumb} 144w`;

        btn.hidden = false;

    } else {

        btn.hidden = true;

    }

});

}

  /**
   * Handles the 'zoom-media:selected' event.
   * @param {ZoomMediaSelectedEvent} event - The zoom-media:selected event.
   */
  #handleZoomMediaSelected = async (event) => {
    this.slideshow?.select(event.detail.index, undefined, { animate: false });
  };

  /**
   * Zooms the media gallery.
   *
   * @param {number} index - The index of the media to zoom.
   * @param {PointerEvent} event - The pointer event.
   */
  zoom(index, event) {
    this.refs.zoomDialogComponent?.open(index, event);
  }

  /**
   * Preloads an image.
   * @param {number} index - The index of the media to preload.
   */
  preloadImage(index) {
    const zoomDialogMedia = this.refs.zoomDialogComponent?.refs.media[index];
    if (!zoomDialogMedia) return;

    this.refs.zoomDialogComponent?.loadHighResolutionImage(zoomDialogMedia);
  }

  get slideshow() {
    return this.refs.slideshow;
  }

  get media() {
    return this.refs.media;
  }

  get presentation() {
    return this.dataset.presentation;
  }
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery);
}
